module.exports = __webpack_public_path__ + "img/get-blaked-logo.de2df37d.png";